var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-alert', {
    staticClass: "sa_note",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_c('div', [_c('strong', [_vm._v("MPPT串列對應")]), _vm._v(" —— 記錄每台 INV 的每個輸入位置接的是哪一個 MPPT、哪一串。 ")]), _c('ul', {
    staticClass: "mb-0 mt-1"
  }, [_c('li', [_vm._v(" 監控資料只記錄各串電壓，不含 MPPT 分組，因此本頁需依現場接線圖人工建立。 可按「"), _c('strong', [_vm._v("快速建立")]), _vm._v("」輸入 INV 台數與 MPPT 數，一次產生所有欄位，再標記未接線的位置。 ")]), _c('li', [_c('strong', [_vm._v("未接線的位置也要建立")]), _vm._v("：填入 MPPT 編號，串列編號留空，以區分「未接線」與「漏填」。 ")]), _c('li', [_vm._v(" 串列編號格式為 "), _c('code', [_vm._v("INV序號-MPPT編號-MPPT內序號")]), _vm._v("（例 "), _c('code', [_vm._v("INV1-3-1")]), _vm._v("），依位置自動帶入， 手動修改後不再自動覆蓋。未接線的位置也佔一個序號，其他串的編號不受影響。 ")]), _c('li', [_vm._v(" 此編號與「拓撲階層」的串列節點編號相同，請"), _c('strong', [_vm._v("先完成本頁，再產生拓撲階層")]), _vm._v("。 ")]), _c('li', [_vm._v("INV 索引從 0 起算（第一台為 0）；MPPT 編號為該台 INV 內的順序，從 1 起算。")])])]), _c('MasterDataTable', _vm._g({
    ref: "table",
    attrs: {
      "table": "mppt_string_map",
      "def": _vm.def,
      "site-code": _vm.siteCode
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('b-button', {
          staticClass: "md_btn",
          attrs: {
            "size": "sm",
            "disabled": !_vm.siteCode,
            "title": "輸入 INV 台數、MPPT 數、每個 MPPT 幾串，一次長出所有格子，再點選空接"
          },
          on: {
            "click": function click($event) {
              _vm.quickOpen = true;
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-th"
        }), _vm._v(" 快速建立 ")])];
      },
      proxy: true
    }])
  }, _vm.$listeners)), _c('MpptQuickBuild', {
    attrs: {
      "site-code": _vm.siteCode
    },
    on: {
      "imported": _vm.onImported
    },
    model: {
      value: _vm.quickOpen,
      callback: function callback($$v) {
        _vm.quickOpen = $$v;
      },
      expression: "quickOpen"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };